import { WORK_FLOW_SOP_INFO_PATH } from '$/api/sopEndpoints';
import type { NodeMaterialItem, NodeMaterialParams } from '$/domains/material/type';
import type { McpType } from '$/domains/mcp/type';
import type { UploadTokenRequestParams } from '@meitu/upload';
import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type { UploadTokenRequestParams } from '@meitu/upload';

export interface UploadConfig {
  type: string;
  app: string;
  uploadSign: (params: UploadTokenRequestParams) => Promise<UploadTokenRequestParams>;
}
export type MaterialParams = Omit<NodeMaterialParams, 'count'>;

export interface MaterialEventConfig<TData = any> {
  getNodeMaterial: (params: MaterialParams & { mcpInfo: McpType | undefined; ids?: string[]; }) => Promise<TData>;
  onBefore?: (prevData?: TData) => void;
  isNoMore: (data: TData) => boolean;
  onSuccess: (data: TData) => NodeMaterialItem[];
  onError?: (Error: Error) => void;
}

interface ISopState {
  fromAdmin: boolean;
  materialEventConfig: MaterialEventConfig | null;
  workflowId: string;
  workFlowSopInfoApi: string;
  uploadConfig: UploadConfig | null;
}
/** Store 会由 API 配置的依赖链提前加载，初始地址不能反向读取 APP。 */
const sopState: StateCreator<ISopState, [
  ['zustand/immer', never],
]> = () => ({
  fromAdmin: false,
  materialEventConfig: null,
  workflowId: '',
  workFlowSopInfoApi: WORK_FLOW_SOP_INFO_PATH,
  uploadConfig: null,
});
const useSopStore: UseBoundStore<StoreApi<ISopState>> = create<ISopState>()(immer(sopState));
export default useSopStore;

/**
 * 设置是否为后台来源
 *
 * @export
 * @param {boolean} value - 是否为后台来源
 */
export function setFromAdmin(value: boolean) {
  useSopStore.setState(() => ({ fromAdmin: value }));
}

/**
 * 设置素材接口事件配置
 *
 * @export
 * @param {MaterialEventConfig} config
 */
export function setMaterialEventConfig(config: MaterialEventConfig) {
  useSopStore.setState(() => ({ materialEventConfig: config }));
}

/**
 * 设置 Workflow ID
 *
 * @export
 * @param {string} workflowId - Workflow ID
 */

export function setWorkflowId(workflowId: string) {
  useSopStore.setState(() => ({ workflowId }));
}

/**
 * 设置 Workflow 信息接口地址
 *
 * @export
 * @param {string} workFlowSopInfoApi
 */
export function setWorkFlowSopInfoApi(workFlowSopInfoApi: string) {
  useSopStore.setState(() => ({ workFlowSopInfoApi }));
}

/**
 * 设置上传配置
 *
 * @export
 * @param {UploadConfig} uploadConfig
 */
export function setUploadConfig(uploadConfig: UploadConfig) {
  useSopStore.setState(() => ({ uploadConfig }));
}
